import { useCallback, useEffect, useState } from 'react';

import { getPasswordResetCooldownRemaining } from '@/utils/passwordResetCooldown';

const usePasswordResetCooldown = () => {
  const [remaining, setRemaining] = useState(() => getPasswordResetCooldownRemaining());
  const refresh = useCallback(() => setRemaining(getPasswordResetCooldownRemaining()), []);

  useEffect(() => {
    const interval = window.setInterval(refresh, 1000);
    return () => window.clearInterval(interval);
  }, [refresh]);

  return { remaining, refresh };
};

export default usePasswordResetCooldown;
